export const initialState = {
    dialogs: {
        deleteConfirm: false,
        // { record, mode, usage }: mode = "version" (a version not in use), "inUse" (the version in use,
        // with others: only the whole template can go) or "template" (the only version).
        deleteTarget: null,
        addConfirm: false,
        useConfirm: false,
        // The row whose version is about to become the one in use.
        useTarget: null,
    },
    forms: {
        addTemplateForm: {
            templateName: "",
            templateFile: null,
        },
    },
    loading: {
        isLoadingBackdrop: false,
    },
    table: {
        searchInput: "",
        currentPage: 1,
        recordsPerPage: 10,
    },
};

export function manageTemplatesReducer(state, action) {
    switch (action.type) {
        case "OPEN_DELETE_DIALOG":
            return {
                ...state,
                dialogs: { ...state.dialogs, deleteConfirm: true, deleteTarget: action.payload },
            };

        case "CLOSE_DELETE_DIALOG":
            return {
                ...state,
                dialogs: { ...state.dialogs, deleteConfirm: false, deleteTarget: null },
            };

        case "OPEN_USE_DIALOG":
            return {
                ...state,
                dialogs: { ...state.dialogs, useConfirm: true, useTarget: action.payload },
            };

        case "CLOSE_USE_DIALOG":
            return {
                ...state,
                dialogs: { ...state.dialogs, useConfirm: false, useTarget: null },
            };

        case "OPEN_ADD_DIALOG":
            return {
                ...state,
                dialogs: { ...state.dialogs, addConfirm: true },
            };

        case "CLOSE_ADD_DIALOG":
            return {
                ...state,
                dialogs: { ...state.dialogs, addConfirm: false },
                forms: {
                    ...state.forms,
                    addTemplateForm: { templateName: "", templateFile: null },
                },
            };

        case "SET_LOADING":
            return {
                ...state,
                loading: { ...state.loading, [action.payload.key]: action.payload.value },
            };

        case "SET_SEARCH_INPUT":
            return {
                ...state,
                table: { ...state.table, searchInput: action.payload, currentPage: 1 },
            };

        case "SET_CURRENT_PAGE":
            return {
                ...state,
                table: { ...state.table, currentPage: action.payload },
            };

        default:
            return state;
    }
}
